// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1FZ34","errors":"Errors_errors__8-fpA"};